// extracted by mini-css-extract-plugin
module.exports = {"refunded-loyalty-info":"_1m4m8cGwgxvH_pyGGseshk","title":"_3WBi4Qypf3Nu9cbie-n31D","loyalty-info-detail":"_1eVlrPDnDavuU-aCPDHHoh"};